export default class Furnace extends Phaser.Sprite {
    constructor(x,y) {
        super(game, x, y, 'items', 'furnace_i01.png');
        this.animations.add('idle', ['furnace_i01.png', 'furnace_i02.png', 'furnace_i03.png', 'furnace_i04.png', 'furnace_i03.png', 'furnace_i02.png'], 6, true).play();
        game.physics.arcade.enableBody(this);
        this.body.immovable = true;

        this.animations.play('idle');

    }

    jump() {
        let x = this.x;
        game.add.tween(this).to({x: x-5}, 200, Phaser.Easing.Back.In, true, 0, 2, true);
    }

}


// WEBPACK FOOTER //
// ./src/objects/furnace.js